import axios from "axios";

import {
  GET_LifestyleMembership,
  RESET_LifestyleMembership,
  LOADING
} from "../actionTypes";
import { DEV_EM_APIS_URL, AWS_SERVER_APIS } from "configurations";
import { adminTokenDev, adminToken } from "../../helper";

const { SET_TRUE, SET_FALSE } = LOADING;

export const get = () => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminToken()
      .then(token =>
        axios.get(
          `${AWS_SERVER_APIS}/lifestylemembership`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch({ type: GET_LifestyleMembership, payload: res.data.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const add = ({ name = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.post(
          `${DEV_EM_APIS_URL}/lifestylemembership`,
          {
            "channel_name": `${name}`
          },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const update = ({ id = "", name = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.put(
          `${DEV_EM_APIS_URL}/lifestylemembership`,
          {
            "id":id,
            "channel_name": `${name}`
        },
          
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const deletedata = ({ id = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.delete(
        `${DEV_EM_APIS_URL}/lifestylemembership/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const reset = () => dispatch => dispatch({ type: RESET_LifestyleMembership });
